module.exports = __webpack_public_path__ + "static/media/drugslogo.b54cf944.png";